import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Auth } from '../../amplify'
import { Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import Loading from 'components/Loading'
import { authBootstrapFailed, authInitialized } from '../selectors'
import { reportAuthInitStalled } from '../authDiagnostics'

const STALL_MS = 15000

const useStyles = makeStyles(theme => ({
  actions: {
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
}))

function AuthInitProblem({ onRefresh, onSignOut }) {
  const classes = useStyles()

  return (
    <>
      <Typography variant="h5" gutterBottom>
        Error while loading your account
      </Typography>
      <Typography color="textSecondary" paragraph>
        Sorry, we were not able to restore your authenticated session. Please try refreshing the page. If that does not
        help, try signing out and signing in again.
      </Typography>
      <div className={classes.actions}>
        <Button variant="contained" color="primary" onClick={onRefresh}>
          Refresh page
        </Button>
        <Button variant="outlined" color="primary" onClick={onSignOut}>
          Sign out
        </Button>
      </div>
    </>
  )
}

export default function AuthInitializedGate(props) {
  const { children } = props
  const initialized = useSelector(authInitialized)
  const bootstrapFailed = useSelector(authBootstrapFailed)
  const [stalled, setStalled] = useState(false)

  useEffect(() => {
    if (initialized || bootstrapFailed) {
      setStalled(false)
      return undefined
    }

    const timer = window.setTimeout(() => {
      setStalled(true)
      reportAuthInitStalled(window.location.pathname)
    }, STALL_MS)

    return () => window.clearTimeout(timer)
  }, [initialized, bootstrapFailed])

  const handleSignOut = () => {
    Auth.signOut()
  }

  if (initialized) {
    return <>{children}</>
  }

  if (bootstrapFailed || stalled) {
    return <AuthInitProblem onRefresh={() => window.location.reload()} onSignOut={handleSignOut} />
  }

  return <Loading />
}
